<template>
  <div>
    <Ocp
      :is-open="isOcpOpen"
      full-width
      @close="toggleOCP(false)"
    >
      <WebshopCart
        :cart="cart"
        :country="country"
        :receipt-props="receiptProps"
        :total-cart-items="totalCartItems"
        :is-wallet-frozen="isWalletFrozen"
        @close="toggleOCP(false)"
        @plus="addOneItemQuantity"
        @minus="removeOneItemQuantity"
        @remove="removeCartItem({ productId: $event.productId })"
        @activate="$router.push($i18n.localePath({ name: 'account-memberships' }))"
        @checkout="onCheckout"
      />
    </Ocp>
    <div class="navbar-wrapper">
      <Navbar
        minimal
        is-webshop
        :wallet-amount="spaazaUser.amount"
        :cart="cart"
        :logo-link="logoLink"
        :login-link="loginLink"
        :account-link="accountLink"
        :menu-items="menuItems"
        :language-dropdown-settings="languageDropdownSettings"
        :country-dropdown-settings="countryDropdownSettings"
        :account-dropdown-settings="accountDropdownSettings"
        :user="user"
        :user-authenticated="isAuthenticated"
        @logout="logout"
        @openCart="toggleOCP(true)"
      />
    </div>
    <nuxt />
  </div>
</template>

<script>
import { authenticated } from '@/mixins/layouts'
import spaazaMixin from '@/mixins/spaaza'
import webshopMixin from '@/mixins/webshop'
import ocpMixin from '@/mixins/ocp'
import Ocp from '@/components/Ocp'
import Navbar from '@/components/Navbar/Navbar'
import WebshopCart from '@/components/Webshop/WebshopCart'
import { togglePageScroll } from '@/utils/general'

export default {
  name: 'LayoutWebshop',
  middleware: 'homepage',
  components: { Navbar, Ocp, WebshopCart },
  mixins: [authenticated, spaazaMixin, webshopMixin, ocpMixin({ hash: 'cart' })],
  async fetch () {
    try {
      await Promise.all([
        this.getSpaazaUser(),
        this.getSpaazaWallet(),
        this.getAndSetShippingDetails(),
        this.getAndSetMemberStats()
      ])
    } catch (error) {
      this.$ota.general.logError(error)
    }
  },
  methods: {
    onCheckout () {
      togglePageScroll(false)
      this.$router.push(this.$i18n.localePath({ name: 'webshop-checkout-shipping' }))
    }
  },
  head () {
    return {
      script: [
        {
          hid: 'webshop-gtm',
          innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-M73VTJX');`,
          type: 'text/javascript'
        }
      ],
      __dangerouslyDisableSanitizersByTagID: {
        'webshop-gtm': ['innerHTML']
      }
    }
  }
}
</script>
